module.exports = __webpack_public_path__ + "img/empty.0dafe0bb.svg";